// Pure model of the Vue portal (src/components/portal), rebuilt over the legacy portal page
// (public/m.eagle/app/pages/home/home.js + home.htm). Inputs are plain snapshots of externis.vmHome taken by
// src/iframe/legacyPortal.js; nothing here touches window, document or the iframe.

export const ECOS_APP = 'eCOSFO';
export const ASSORT_APP = 'ASSFO';

// home.js buildApps(): an icon per eCOS application; any other one is an external application, shown with
// its image (or a question mark) and opened in a new window (clickHandler's `blank`).
const APP_ICONS = { [ECOS_APP]: 'business_center', [ASSORT_APP]: 'barcode', 'BO v2': 'settings', PSPFO: 'diversity_3' };

// buildApps() prefixes relative images with /m.eagle (and writes it back on the model, hence the guard).
export function appImageUrl(imageUrl) {
	const url = String(imageUrl ?? '');
	if (!url) return null;
	return !url.includes('m.eagle') && url.startsWith('/') ? `/m.eagle${url}` : url;
}

export function portalTile(app) {
	const reference = String(app?.reference ?? '');
	const icon = APP_ICONS[reference] ?? null;
	const image = icon ? null : appImageUrl(app?.imageUrl);
	return { id: app?.id ?? null, reference, label: app?.label ?? '', icon: icon ?? (image ? null : 'question_mark'), image, blank: !icon };
}

// setupApps() already sorted and filtered the list. Assort is hidden when its menus are empty or its access
// was denied (home.js __successAssort / _applyOfflineAppVisibility, both through APP_ACCESS_RIGHTS).
export function portalTiles(apps, { assortAllowed = true } = {}) {
	return (Array.isArray(apps) ? apps : []).filter((app) => app?.reference && (assortAllowed || app.reference !== ASSORT_APP)).map(portalTile);
}

// home.htm reads languages[getCurrentLanguageShortCode().toLowerCase()]: the short code of the user's locale.
export const newsLanguage = (locale) =>
	String(locale || 'fr-FR')
		.split('-')[0]
		.toLowerCase();

// public/m.eagle/news.json items; the legacy template threw on a language an item lacks, French is the fallback.
export function portalNews(items, locale) {
	const language = newsLanguage(locale);
	return (Array.isArray(items) ? items : [])
		.map((item, index) => {
			const text = item?.languages?.[language] ?? item?.languages?.fr ?? null;
			if (!text?.title) return null;
			return { key: `${index}-${item.date ?? ''}`, date: item.date ?? '', icon: item.icon || 'release_alert', background: item.background || null, title: text.title, description: text.description ?? '', link: text.link || null };
		})
		.filter(Boolean);
}
